import rules from '../../constants/businessRules/businessRules';
import emitter from './emitter';

const postMessage = (msg, type) => {
    const message = { payload: msg, type, target: 'pikassoParentWindow' };
    window.parent.postMessage(message, '*');
};

const registerEvents = () => {
    Object.values(rules.EVENT_EMITTER_EVENTS).forEach((event) => {
        const handler = (msg) => postMessage(msg, event);
        emitter.on(event, handler);
    });
};

export default registerEvents;
